import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { type AbstractModel, AbstractModelImpl } from '@/services/common/abstract-model';
import type { AIDisclosureState } from '../type/ai-disclosure.type';
import { AIDisclosureStep } from '../type/ai-disclosure.enum';

export const AIDisclosureModel = Symbol('AIDisclosureModel');

export interface AIDisclosureModel extends AbstractModel<AIDisclosureState> {
}

@injectable()
export class AIDisclosureModelImpl extends AbstractModelImpl<AIDisclosureState> implements AIDisclosureModel {
    protected _modelData: AIDisclosureState = {
        input: '',
        currentStep: AIDisclosureStep.DEFAULT,
    };
}
